import { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import './Button.css';

const Button = forwardRef(
  (
    {
      children,
      type,
      variant,
      size,
      onClick,
      onChange,
      rounded,
      className,
      disabled,
    },
    ref
  ) => {
    const classConfig = {
      //  sizes
      size: { small: 'btn-small', medium: 'btn-medium', large: 'btn-large' },
      //  variants
      variant: {
        text: 'btn-text',
        contained: 'btn-contained',
        outlined: 'btn-outlined',
        default:
          'bg-blue-900 text-white hover:bg-[#00449e] font-bold duration-500',
        success:
          'bg-green-600 text-white hover:bg-green-500 font-bold duration-500',
        danger: 'bg-red-600 text-white hover:bg-red-500 font-bold duration-500',
      },
      // border-radius
      rounded: {
        none: 'btn-rounded-none',
        medium: 'btn-rounded-medium',
        full: 'btn-rounded-full',
      },
    };
    return (
      <button
        ref={ref}
        className={`btn ${classConfig.size[size]} ${
          classConfig.variant[variant]
        } ${classConfig.rounded[rounded]} ${
          className ? className : ''
        } disabled:bg-slate-300 disabled:text-black `}
        type={type}
        disabled={disabled}
        onClick={(e) => {
          if (onClick) {
            onClick(e);
          }
        }}
        onChange={(e) => {
          if (onChange) {
            onChange(e);
          }
        }}
      >
        {children}
      </button>
    );
  }
);

// displayName property added for debugging since forwardRef is used
Button.displayName = 'Button';

Button.propTypes = {
  variant: PropTypes.oneOf(['text', 'contained', 'outlined']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  children: PropTypes.node,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  rounded: PropTypes.oneOf(['full', 'none', 'medium']),
  className: PropTypes.string,
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  variant: 'contained',
  size: 'small',
  rounded: 'medium',
  type: 'button',
  disabled: false,
};

export default memo(Button);
